// src/pages/ConfirmedRoutes.jsx
import React from "react";
import { RouteListPage } from "../components/RouteListPage";

import { t } from "../i18n";
export default function ConfirmedRoutes() {
  return (
    <RouteListPage
      status="CONFIRMED"
      eyebrow={t("confirmed.eyebrow")}
      title={t("confirmed.title")}
      lead={t("confirmed.lead")}
      detailPath="/confirmed-route"
      emptyTitle={t("confirmed.empty_title")}
      emptyMessage={t("confirmed.empty_message")}
      paymentFilter
    />
  );
}
